import React, { Component, Fragment } from "react";
import ReactScroll from "react-scroll";
import { browserHistory } from "react-router";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import I18n from "lib/i18n/i18n";
import WorthyApi from "lib/api/worthyApi";
import UserActions from "lib/userActions";
import { dollarsWithoutCents, isMobile } from "helpers/ApplicationHelper";
import ImageGallery from "components/imageGallery";
import Properties from "components/item/properties";
import Popup from "components/popups/popup";
import { PopupSimilarItems } from "components/popups/popupSimilarItems";
import { InputTextArea, InputRadio, InputText } from "components/formElements";
import PopupTooltipSuccessFee from "components/popups/popupTooltipSuccessFee";
import {
    ShortCtaPopup,
    LongCtaPopup,
    LargePrimaryButton,
    LargeSecondaryButton,
    LargeLinkButton,
    ModalPattern,
} from "@worthy-npm/clarity";

dayjs.extend(utc);
dayjs.extend(timezone);
class PopupHighReservePrice extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    componentDidMount() {
        this.logAction("high_reserve_price_alert_presented");
    }

    componentWillUnmount() {
        !this.dontSendCloseEvent &&
            this.logAction("high_reserve_price_alert_closed");
    }

    logAction(event, value = null) {
        UserActions.sya(event, value, this.props.textVersion);
    }

    title() {
        return (
            <span style={{ font: '700 24px/40px "Open Sans"' }}>
                {I18n.getString(
                    `itemPage::pendingAuction::${this.props.textVersion}::highReservePricePopup::title`
                )}
            </span>
        );
    }

    content() {
        return (
            <div>
                {I18n.getString(
                    `itemPage::pendingAuction::${this.props.textVersion}::highReservePricePopup::text_1`
                )}
                <br />
                <br />
                {I18n.getString(
                    `itemPage::pendingAuction::${this.props.textVersion}::highReservePricePopup::text_2`
                )}
                <button
                    className="btn btn-gold edit-reserve-price"
                    onClick={this.edit.bind(this)}
                >
                    {I18n.getString(
                        `itemPage::pendingAuction::${this.props.textVersion}::highReservePricePopup::buttonEdit`
                    )}
                </button>
                <button
                    className="btn btn-white keep-reserve-price"
                    onClick={this.continue.bind(this)}
                >
                    {I18n.getString(
                        `itemPage::pendingAuction::${this.props.textVersion}::highReservePricePopup::buttonContinue`
                    )}
                </button>
            </div>
        );
    }

    edit() {
        this.logAction("rp_edit_price_triggered");
        this.props.editCallback();
        this._hide();
    }

    continue() {
        this.dontSendCloseEvent = true;
        this.logAction("rp_keep_price_triggered");
        this.props.continueCallback();
        this._hide();
    }
}
PopupHighReservePrice.defaultProps = {
    popupClassName:
        "popup-tooltip popup-tooltip-high-reserve-price popup-compact",
    single: true,
    modal: true,
    classNames: ["no-animation"],
};

export default class PendingAuction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            setManually: false,
            textVersion: props.syaExp ? "B" : "A",
            showPriceGuaranteePopup: false,
            showHeadsUpPopup: false,
            showHeadsUpPopupNew: false,
            showOverlay: false,
            isHighPriceGuaranteeModalOpen: false,
        };

        this.collapsibleOpened = false;
        this.advancePayment = true;
        this.priceGuarantee = true;
        this.reservePrice = Math.floor(
            props.item.recommended_minimum_reserve_price
        );

        this.openSimilarItemsPopup = this.openSimilarItemsPopup.bind(this);
        this.resetReservePriceInput = this.resetReservePriceInput.bind(this);
        this.startAuction = this.startAuction.bind(this);
        this.tryStartAuction = this.tryStartAuction.bind(this);
        this.onStartAuctionClick = this.onStartAuctionClick.bind(this);
        this.onStartPGAuctionClick = this.onStartPGAuctionClick.bind(this);
        this.onStartRPAuctionClick = this.onStartRPAuctionClick.bind(this);
        this.onRadioBtnChange = this.onRadioBtnChange.bind(this);
        this.onCustomReservePriceChanged =
            this.onCustomReservePriceChanged.bind(this);
        this.onSwitchButtonClick = this.onSwitchButtonClick.bind(this);
        this.logAction = this.logAction.bind(this);
        this.showPriceGuaranteePopup = this.showPriceGuaranteePopup.bind(this);
        this.hidePriceGuaranteePopup = this.hidePriceGuaranteePopup.bind(this);
        this.showHeadsUpPopup = this.showHeadsUpPopup.bind(this);
        this.hideHeadsUpPopup = this.hideHeadsUpPopup.bind(this);
        this.renderNoGuarantee = this.renderNoGuarantee.bind(this);
        this.renderNoGuaranteeNewDesign =
            this.renderNoGuaranteeNewDesign.bind(this);
        this.renderHighPriceGuaranteeModal =
            this.renderHighPriceGuaranteeModal.bind(this);
    }

    componentDidMount() {
        this.logAction("start_auction_page_presented");
    }

    get reservePriceMinDollars() {
        return dollarsWithoutCents(this.props.item.reserve_price_range[0]);
    }

    get reservePriceMaxDollars() {
        return dollarsWithoutCents(this.props.item.reserve_price_range[1]);
    }

    get reservePriceMaxAdditional5Pct() {
        return this.props.item.reserve_price_range[1] * 1.05;
    }

    get disableAdvancePaymentClass() {
        return this.props.item.disable_advance_payment_and_price_guarantee
            ? "openedSection"
            : "";
    }

    get radioButtonOptions() {
        let options = {};
        for (let key in I18n.getVar(
            `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::hidden::radioOptions`
        )) {
            let line1 = I18n.getJsx(
                    `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::hidden::radioOptions::${key}::text1`,
                    {
                        price:
                            key === "recommended" ? (
                                <span className="bold">
                                    {this.reservePriceMaxDollars}
                                </span>
                            ) : key === "recommendedAdditional5" ? (
                                <span className="bold">
                                    {dollarsWithoutCents(
                                        this.reservePriceMaxAdditional5Pct
                                    )}
                                </span>
                            ) : null,
                        text:
                            key === "recommended" ? (
                                <span className="recommended-text">
                                    recommended
                                </span>
                            ) : (
                                ""
                            ),
                    }
                ),
                colorClassName =
                    (["recommended", "recommendedAdditional5"].includes(key) &&
                        "gray") ||
                    null,
                line2 = (
                    <div className={`after-radio-text ${colorClassName}`}>
                        {I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::hidden::radioOptions::${key}::text2`
                        )}
                    </div>
                );
            options[key] = (
                <Fragment>
                    {line1}
                    {line2}
                </Fragment>
            );
        }
        return options;
    }

    logAction(event, value = null) {
        UserActions.sya(event, value, this.state.textVersion);
    }

    renderHighPriceGuaranteeModal() {
        const closeModal = () => {
            this.resetReservePriceInput();
            this.setState({ isHighPriceGuaranteeModalOpen: false });
        };

        return (
            <ModalPattern
                title={I18n.getString(
                    `itemPage::pendingAuction::${this.state.textVersion}::highReservePricePopup::title`
                )}
                closeOnEscape={false}
                closeOnClickOutside={false}
                onClose={closeModal}
            >
                <div
                    style={{
                        fontSize: "16px",
                        lineHeight: "26px",
                        marginBottom: "25px",
                    }}
                >
                    {I18n.getString(
                        `itemPage::pendingAuction::${this.state.textVersion}::highReservePricePopup::text_1`
                    )}
                    <br />
                    <br />
                    {I18n.getString(
                        `itemPage::pendingAuction::${this.state.textVersion}::highReservePricePopup::text_2`
                    )}
                </div>
                <div className="modal-control-buttons">
                    <LargeLinkButton
                        text={I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::highReservePricePopup::buttonContinue`
                        )}
                        click={() => {
                            this.startAuction();
                            this.setState({
                                isHighPriceGuaranteeModalOpen: false,
                            });
                        }}
                        disableAnimation
                    />
                    <LargePrimaryButton
                        text={I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::highReservePricePopup::buttonEdit`
                        )}
                        click={closeModal}
                        disableAnimation
                    />
                </div>
            </ModalPattern>
        );
    }

    render() {
        const { item } = this.props;

        if (item.scheduled_auction) {
            return (
                <>
                    <h1 id="scheduled-auction-title">
                        {I18n.getString(
                            "itemPage::scheduledAuction::titleScheduled"
                        )}
                    </h1>
                    {this.renderScheduledAuctionInfo()}
                    <div id="item-pending-auction-new">
                        {this.renderTitleSection(<></>)}
                        <Properties item={item} showSellerNotes={false} />
                        {this.renderSellerNotesSection(true)}
                    </div>
                </>
            );
        }
        return (
            <div id="item-pending-auction-new">
                {this.state.isHighPriceGuaranteeModalOpen &&
                    this.renderHighPriceGuaranteeModal()}
                {this.renderTitleSection()}
                <Properties item={item} showSellerNotes={false} />
                {this.renderSellerNotesSection()}
                {this.renderPreScheduledAuctionInfo()}
                {this.renderSYASection()}
            </div>
        );
    }

    renderTitleSection(customTitle = null) {
        return (
            <Fragment>
                {customTitle || (
                    <h1>
                        {I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::title`
                        )}
                    </h1>
                )}
                <h2 className="item-desc">{this.props.item.desc}</h2>
                <ImageGallery
                    images={
                        this.props.item.images
                            ? this.props.item.images.slice(0, 4)
                            : []
                    }
                />
            </Fragment>
        );
    }

    renderSellerNotesSection(readonly = false) {
        if (readonly && !this.props.item.seller_notes) {
            return null;
        }

        return (
            <div id="seller-notes-section">
                <h3>{I18n.getString("itemPage::sellerNotes::title")}</h3>
                {readonly ? (
                    <p>{this.props.item.seller_notes}</p>
                ) : (
                    <>
                        <InputTextArea
                            ref="sellerNotes"
                            name="sellerNotes"
                            defaultValue={this.props.item.seller_notes}
                            inputProps={{
                                required: false,
                                autoFocus: false,
                                placeholder: I18n.getString(
                                    "itemPage::sellerNotes::inputPlaceholder"
                                ),
                                maxLength: 200,
                            }}
                        />
                        <div className="help">
                            {I18n.getString("itemPage::sellerNotes::subText")}
                        </div>
                    </>
                )}
            </div>
        );
    }

    renderKey(key) {
        let replacenNull = { 0: null },
            replaceReserveRange = {
                0: (
                    <a onClick={this.openSimilarItemsPopup}>{`Similar ${
                        this.props.syaExp
                            ? this.props.item["item_type"]
                            : "items"
                    }`}</a>
                ),
                1: (
                    <span>{`${this.reservePriceMinDollars}-${this.reservePriceMaxDollars}`}</span>
                ),
            },
            replaceReservePrice = {
                0: <span>{this.reservePriceMaxDollars}</span>,
            };
        let resSyaA, resSyaB;
        switch (key) {
            case "0":
                resSyaA = replaceReserveRange;
                resSyaB = replaceReservePrice;
                break;
            case "1":
            case "2":
                resSyaA = replaceReservePrice;
                resSyaB = replacenNull;
                break;
            case "3":
                resSyaA = replaceReservePrice;
                resSyaB = replaceReserveRange;
                break;
            default:
                resSyaA = resSyaB = replacenNull;
        }
        return I18n.getJsx(
            `itemPage::pendingAuction::${this.state.textVersion}::priceGuarantee::infoTexts::${key}`,
            this.props.syaExp ? resSyaB : resSyaA
        );
    }

    renderPreScheduledAuctionInfo() {
        const isNewDesignExp =
            this.props.isNoGuaranteeNewDesignExp &&
            this.props.item.disable_advance_payment_and_price_guarantee;
        const date = dayjs(
            this.props.item.scheduled_auction_upcoming_date
        ).format("MM/DD/YYYY");

        if (!this.props.item.can_be_scheduled) {
            return null;
        }

        return (
            <div id="scheduled-auction-info">
                <h3>
                    {I18n.getString(
                        "itemPage::scheduledAuction::titlePreScheduled"
                    )}
                </h3>
                <h5
                    className={`${this.disableAdvancePaymentClass} ${
                        isNewDesignExp && "new-design"
                    }`}
                    dangerouslySetInnerHTML={{
                        __html: I18n.getString(
                            "itemPage::scheduledAuction::textPreScheduled",
                            {
                                date,
                            }
                        ),
                    }}
                />
            </div>
        );
    }

    renderScheduledAuctionInfo() {
        const { item } = this.props;
        const scheduledAuctionDate = dayjs(
            item.scheduled_auction_upcoming_date
        );
        const dow = scheduledAuctionDate.format("dddd");
        const date = scheduledAuctionDate.format("MM/DD/YYYY");
        const time = scheduledAuctionDate
            .tz("America/New_York")
            .format("h:mmA");

        return (
            <div id="scheduled-auction-info" style={{ padding: "0 15px" }}>
                <p
                    dangerouslySetInnerHTML={{
                        __html: I18n.getString(
                            "itemPage::scheduledAuction::textScheduled1",
                            { dow, date, time }
                        ),
                    }}
                />
                <p
                    className="light"
                    dangerouslySetInnerHTML={{
                        __html: I18n.getString(
                            "itemPage::scheduledAuction::textScheduled2"
                        ),
                    }}
                />
            </div>
        );
    }

    renderSYASection() {
        let priceGuaranteeTexts = I18n.getVar(
            `itemPage::pendingAuction::${this.state.textVersion}::priceGuarantee::infoTexts`
        );
        const isNewDesignExp =
            this.props.isNoGuaranteeNewDesignExp &&
            this.props.item.disable_advance_payment_and_price_guarantee;

        if (this.props.item.similar_items.length < 2) {
            let res = _.filter(priceGuaranteeTexts, (txt) => {
                return txt.match(new RegExp("^{similarItemsLink}"));
            });
            delete priceGuaranteeTexts[
                Object.values(priceGuaranteeTexts).indexOf(res[0])
            ];
        }
        return (
            <div id="sya">
                <h3>
                    {this.props.item.disable_advance_payment_and_price_guarantee
                        ? I18n.getString(
                              `itemPage::pendingAuction::${this.state.textVersion}::syaTitleAbovePG`
                          )
                        : I18n.getString(
                              `itemPage::pendingAuction::${this.state.textVersion}::syaTitle`
                          )}
                </h3>
                <h5
                    className={`${this.disableAdvancePaymentClass} ${
                        isNewDesignExp && "new-design"
                    }`}
                    dangerouslySetInnerHTML={{
                        __html: this.props.item
                            .disable_advance_payment_and_price_guarantee
                            ? I18n.getString(
                                  `itemPage::pendingAuction::${this.state.textVersion}::syaSubtitleAbovePG`
                              )
                            : I18n.getString(
                                  `itemPage::pendingAuction::${this.state.textVersion}::syaSubtitle`
                              ),
                    }}
                />
                <div
                    id="price-guarantee"
                    className={
                        this.props.item
                            .disable_advance_payment_and_price_guarantee
                            ? "hidden"
                            : "option-box"
                    }
                >
                    <span className="shining-star" />
                    <span className="tag">
                        {I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::priceGuarantee::tag`
                        )}
                    </span>
                    <div className="box-title bolder">
                        {I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::priceGuarantee::title`
                        )}
                    </div>
                    <div>
                        {I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::priceGuarantee::beforePrice`
                        )}
                    </div>
                    <div className="price">{this.reservePriceMaxDollars}</div>
                    {this.renderSuccessFeesLink("price_guaranteed")}
                    <div className="info-texts">
                        {Object.keys(priceGuaranteeTexts).map((key) => {
                            return (
                                <div key={key} className="info-text-item">
                                    {this.renderKey(key)}
                                </div>
                            );
                        })}
                    </div>
                    <button
                        className="btn btn-orange"
                        onClick={this.showPriceGuaranteePopup}
                    >
                        {I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::priceGuarantee::cta`
                        )}
                    </button>
                </div>
                {this.renderPriceGuaranteePopup()}

                {this.props.isNoGuaranteeNewDesignExp &&
                this.props.item.disable_advance_payment_and_price_guarantee
                    ? this.renderNoGuaranteeNewDesign()
                    : this.renderNoGuarantee()}
            </div>
        );
    }

    renderNoGuaranteeNewDesign() {
        const { setManually, textVersion } = this.state;
        const noPriceGuaranteeTexts = I18n.getVar(
            `itemPage::pendingAuction::${textVersion}::noGuaranteeNew::infoTexts`
        );
        const reservePriceReplacement = {
            reservePriceDollars: <span>{this.reservePriceMaxDollars}</span>,
        };

        return (
            <div id="no-guarantee-new" className="option-box">
                {this.renderHeadsUpPopupNew()}
                <span className="shining-star" />
                <div className="box-title bolder">
                    {I18n.getString(
                        `itemPage::pendingAuction::${textVersion}::noGuaranteeNew::title`
                    )}
                </div>
                <div className="price">{this.reservePriceMaxDollars}</div>
                {this.renderSuccessFeesLink("no_guarantee_new")}
                <div className="info-texts">
                    {Object.keys(noPriceGuaranteeTexts).map((key) => {
                        return (
                            <div key={key} className="info-text-item">
                                {I18n.getJsx(
                                    `itemPage::pendingAuction::${textVersion}::noGuaranteeNew::infoTexts::${key}`,
                                    key === "0" ? reservePriceReplacement : {}
                                )}
                            </div>
                        );
                    })}
                </div>
                <div className="stretch-clarity-btn-wrap">
                    <LargePrimaryButton
                        text={I18n.getJsx(
                            `itemPage::pendingAuction::${textVersion}::noGuaranteeNew::cta`,
                            reservePriceReplacement
                        )}
                        click={() => this.setRecommendedReserve()}
                        disableAnimation
                    />
                </div>
                {!setManually && (
                    <div className="cat-manual-wrap stretch-clarity-btn-wrap">
                        <LargeSecondaryButton
                            text={I18n.getJsx(
                                `itemPage::pendingAuction::${textVersion}::noGuaranteeNew::cta_manually`
                            )}
                            click={() => this.setState({ setManually: true })}
                            disableAnimation
                        />
                    </div>
                )}
                {setManually && (
                    <div
                        className={`option-box manual-part-new`}
                        id="no-guarantee"
                    >
                        {this.renderHeadsUpPopup()}
                        <div
                            className={`collapsible big ${this.disableAdvancePaymentClass}`}
                        >
                            <div className="separator new-design" />
                            <h4 className="bold in-uppercase">
                                {I18n.getString(
                                    `itemPage::pendingAuction::${textVersion}::noGuaranteeNew::manualPart::title`
                                )}
                            </h4>
                            <div>
                                {I18n.getString(
                                    `itemPage::pendingAuction::${textVersion}::noGuarantee::hidden::subtitle`
                                )}
                            </div>
                            {this.renderSuccessFeesLink("no_guarantee")}
                            <InputRadio
                                options={this.radioButtonOptions}
                                defaultValue="recommended"
                                ref="auto-reserve-price"
                                name="auto-reserve-price"
                                onAfterChange={this.onRadioBtnChange}
                            />
                            <div className="collapsible small">
                                <span className="additional-text">{`${this.reservePriceMaxDollars} Recommended`}</span>
                                <InputText
                                    ref="custom-reserve-price"
                                    name="custom-reserve-price"
                                    inputId="custom-reserve-price"
                                    inputProps={{
                                        required: false,
                                        autoFocus: false,
                                        id: "custom-reserve-price",
                                        min: 0,
                                        maxLength: 10,
                                        onChange:
                                            this.onCustomReservePriceChanged,
                                        onFocus: this.logAction.bind(
                                            this,
                                            "reserve_price_focus",
                                            null
                                        ),
                                        onBlur: () => {
                                            this.logAction(
                                                "reserve_price_entered",
                                                this.reservePrice
                                            );
                                        },
                                    }}
                                />
                            </div>
                            <div className="set-manual-btn-wrap stretch-clarity-btn-wrap">
                                <LargePrimaryButton
                                    text={I18n.getString(
                                        `itemPage::pendingAuction::${textVersion}::noGuaranteeNew::manualPart::cta`
                                    )}
                                    click={() => this.tryStartAuction()}
                                    disableAnimation
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    setRecommendedReserve() {
        this.reservePrice = Math.floor(
            this.props.item.recommended_minimum_reserve_price
        );
        this.showHeadsUpPopup(true);
    }
    renderNoGuarantee() {
        return (
            <div
                className={`option-box ${this.disableAdvancePaymentClass}`}
                id="no-guarantee"
            >
                {this.renderHeadsUpPopup()}
                <div
                    className={
                        this.props.item
                            .disable_advance_payment_and_price_guarantee
                            ? "hidden"
                            : "box-title bolder"
                    }
                >
                    {I18n.getString(
                        `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::title`
                    )}
                </div>
                <div
                    className={
                        this.props.item
                            .disable_advance_payment_and_price_guarantee
                            ? "hidden"
                            : "info-texts"
                    }
                >
                    {Object.keys(
                        I18n.getVar(
                            `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::infoTexts`
                        )
                    ).map((key) => {
                        return (
                            <div key={key} className="info-text-item">
                                <span>
                                    {I18n.getString(
                                        `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::infoTexts::${key}`
                                    )}
                                </span>
                            </div>
                        );
                    })}
                </div>
                <div
                    className={`collapsible big ${this.disableAdvancePaymentClass}`}
                >
                    <div
                        className={
                            this.props.item
                                .disable_advance_payment_and_price_guarantee
                                ? "hidden"
                                : "separator"
                        }
                    />
                    <h4 className="bold">
                        {I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::hidden::title`
                        )}
                    </h4>
                    <div>
                        {I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::hidden::subtitle`
                        )}
                    </div>
                    <div className="subtitle-second">
                        {I18n.getString(
                            `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::hidden::subtitle_second`
                        )}
                    </div>
                    {this.renderSuccessFeesLink("no_guarantee")}
                    <InputRadio
                        options={this.radioButtonOptions}
                        defaultValue="recommended"
                        ref="auto-reserve-price"
                        name="auto-reserve-price"
                        onAfterChange={this.onRadioBtnChange}
                    />
                    <div className="collapsible small">
                        <span className="additional-text">{`${this.reservePriceMaxDollars} Recommended`}</span>
                        <InputText
                            ref="custom-reserve-price"
                            name="custom-reserve-price"
                            inputId="custom-reserve-price"
                            inputProps={{
                                required: false,
                                autoFocus: false,
                                id: "custom-reserve-price",
                                min: 0,
                                maxLength: 10,
                                onChange: this.onCustomReservePriceChanged,
                                onFocus: this.logAction.bind(
                                    this,
                                    "reserve_price_focus",
                                    null
                                ),
                                onBlur: () => {
                                    this.logAction(
                                        "reserve_price_entered",
                                        this.reservePrice
                                    );
                                },
                            }}
                        />
                    </div>
                </div>
                {this.renderSwitchBtn()}
            </div>
        );
    }

    renderSwitchBtn() {
        if (this.props.item.disable_advance_payment_and_price_guarantee) {
            return (
                <button
                    className="btn btn-white"
                    onClick={this.tryStartAuction}
                >
                    {I18n.getString(
                        `itemPage::pendingAuction::${this.state.textVersion}::priceGuarantee::cta`
                    )}
                </button>
            );
        } else {
            return (
                <button
                    className="btn btn-white"
                    id="switch-btn"
                    onClick={this.onSwitchButtonClick}
                >
                    {I18n.getString(
                        `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::cta`
                    )}
                </button>
            );
        }
    }

    renderSuccessFeesLink(boxName) {
        const suffix =
            boxName === "no_guarantee" && this.state.setManually
                ? "_after_set_manually"
                : "";
        return (
            <div
                className={`success-fees ${this.disableAdvancePaymentClass} ${
                    boxName === "no_guarantee"
                        ? "add-margin"
                        : boxName === "no_guarantee_new"
                        ? "drop-margin"
                        : ""
                }`}
            >
                {I18n.getJsx(
                    `itemPage::pendingAuction::${this.state.textVersion}::successFeesLink`,
                    {
                        link: (
                            <a
                                onClick={() =>
                                    PopupTooltipSuccessFee.initPopup({
                                        page: "pending_auction",
                                        openEvent: `worthy_success_fees_${boxName}_opened${suffix}`,
                                        closeEvent: `worthy_success_fees_${boxName}_closed${suffix}`,
                                    })
                                }
                            >
                                {I18n.getString(
                                    `itemPage::pendingAuction::${this.state.textVersion}::successFeesLinkText`
                                )}
                            </a>
                        ),
                    }
                )}
            </div>
        );
    }

    renderPriceGuaranteePopup() {
        if (this.state.showPriceGuaranteePopup) {
            this.advancePayment = true;
            this.priceGuarantee = true;
            this.reservePrice = Math.floor(
                this.props.item.recommended_minimum_reserve_price
            );
            return (
                <div>
                    <div className="modal-container">
                        <ShortCtaPopup
                            headline={
                                <span className="bolder">It’s a deal</span>
                            }
                            html={[
                                I18n.getString(
                                    `itemPage::pendingAuction::${this.state.textVersion}::priceGuaranteePopup::text_1`
                                ),
                                <span className="bolder" key="1">
                                    {this.reservePriceMaxDollars}
                                </span>,
                                I18n.getString(
                                    `itemPage::pendingAuction::${this.state.textVersion}::priceGuaranteePopup::text_2`,
                                    {
                                        item_type: this.props.item[
                                            "item_type"
                                        ].replace(/s$/, ""),
                                    }
                                ),
                            ]}
                            declineButtonClick={this.hidePriceGuaranteePopup}
                            declineButtonText={I18n.getString(
                                `itemPage::pendingAuction::${this.state.textVersion}::priceGuaranteePopup::declineButtonText`
                            )}
                            approveButtonText={I18n.getString(
                                `itemPage::pendingAuction::${this.state.textVersion}::priceGuaranteePopup::approveButtonText`
                            )}
                            approveButtonClick={this.onStartPGAuctionClick}
                            icon="hammer"
                        />
                    </div>
                    {this.renderOverlay()}
                </div>
            );
        }
    }

    renderHeadsUpPopup() {
        if (this.state.showHeadsUpPopup) {
            this.advancePayment = false;
            this.priceGuarantee = false;
            return (
                <div>
                    <div className="modal-container">
                        <ShortCtaPopup
                            headline={
                                <span className="bolder">
                                    Confirm Your Reserve
                                </span>
                            }
                            text="Once the auction meets or exceeds your reserve price, it's a deal and the sale can’t be canceled."
                            declineButtonClick={this.hideHeadsUpPopup}
                            declineButtonText="Cancel"
                            approveButtonText="Agree"
                            approveButtonClick={this.onStartRPAuctionClick}
                            icon="notebook"
                        />
                    </div>
                    {this.renderOverlay()}
                </div>
            );
        }
    }

    renderHeadsUpPopupNew() {
        if (this.state.showHeadsUpPopupNew) {
            this.advancePayment = false;
            this.priceGuarantee = false;

            const i18nStringBase = `itemPage::pendingAuction::${this.state.textVersion}::noGuaranteeNew::headsUpPopupNew`;

            return (
                <div>
                    <div className="modal-container">
                        <LongCtaPopup
                            headline={
                                <span className="bolder">
                                    {I18n.getString(
                                        `${i18nStringBase}::headline`
                                    )}
                                </span>
                            }
                            text={I18n.getString(`${i18nStringBase}::text`)}
                            declineButtonClick={() =>
                                this.hideHeadsUpPopup(true)
                            }
                            declineButtonText={I18n.getString(
                                `${i18nStringBase}::declineBtn`
                            )}
                            approveButtonText={I18n.getString(
                                this.props.item.can_be_scheduled
                                    ? `${i18nStringBase}::confirm`
                                    : `${i18nStringBase}::approveBtn`
                            )}
                            approveButtonClick={this.onStartRPAuctionClick}
                            icon="notebook"
                        />
                    </div>
                    {this.renderOverlay()}
                </div>
            );
        }
    }

    renderOverlay() {
        if (this.state.showOverlay) {
            document.body.style.overflowY = "hidden";
            document.body.style.position = "fixed";
            document.body.style.width = "100%";
            return <div className="overlay"></div>;
        }
    }

    removeOverlay() {
        document.body.style.overflowY = "";
        document.body.style.position = "";
    }

    hideHeadsUpPopup(isNewVersion = false) {
        this.setState({
            [isNewVersion ? "showHeadsUpPopupNew" : "showHeadsUpPopup"]: false,
        });
        this.setState({ showOverlay: false });
        this.removeOverlay();

        this.logAction("cancel_rp");
    }

    showHeadsUpPopup(isNewVersion = false) {
        this.setState({
            [isNewVersion ? "showHeadsUpPopupNew" : "showHeadsUpPopup"]: true,
        });
        this.setState({ showOverlay: true });
    }

    hidePriceGuaranteePopup() {
        this.setState({ showPriceGuaranteePopup: false });
        this.setState({ showOverlay: false });
        this.removeOverlay();

        this.logAction("cancel_pg");
    }

    showPriceGuaranteePopup() {
        this.setState({ showPriceGuaranteePopup: true });
        this.setState({ showOverlay: true });

        this.logAction("pg_popup_appears");
    }

    openSimilarItemsPopup() {
        this.logAction("similar_items_clicked");
        PopupSimilarItems.initPopup({ item: this.props.item });
    }

    resetReservePriceInput() {
        const inputElm = document.querySelector("#custom-reserve-price");
        inputElm.value = "";
        this.refs["custom-reserve-price"].clearErrors();
        this.onCustomReservePriceChanged({ target: inputElm }); // because changing value via javascript doesn't raise the event
        inputElm.focus();
    }

    tryStartAuction() {
        if (!this.reservePrice) {
            const collapsibleBig = document.querySelector(".collapsible.big"),
                collapsibleSmall = document.querySelector(".collapsible.small");
            this.refs["custom-reserve-price"].setError(
                I18n.getString(
                    `itemPage::pendingAuction::${this.state.textVersion}::errors::noReservePrice`
                )
            );
            collapsibleBig.style.setProperty(
                "max-height",
                parseInt(collapsibleBig.style.maxHeight) + 20 + "px"
            );
            collapsibleSmall.style.setProperty(
                "max-height",
                parseInt(collapsibleSmall.style.maxHeight) + 20 + "px"
            );
        } else if (this.reservePrice > this.reservePriceMaxAdditional5Pct) {
            // this.priceGuarantee = false;
            if (isMobile()) {
                this.setState({ isHighPriceGuaranteeModalOpen: true }); // in case of mobile open modal from clarity
            } else {
                PopupHighReservePrice.initPopup({
                    price: this.props.item.recommended_minimum_reserve_price,
                    editCallback: this.resetReservePriceInput,
                    continueCallback: this.startAuction,
                    textVersion: this.state.textVersion,
                    onPopupClose: () => {},
                });
            }

            this.logAction(
                "start_auction_reserve_price_entered",
                this.reservePrice
            );
        } else {
            switch (this.refs["auto-reserve-price"].state.value) {
                case "recommended":
                    this.logAction(
                        "start_auction_price_recommended",
                        this.reservePrice
                    );
                    this.showHeadsUpPopup();
                    break;
                case "recommendedAdditional5":
                    this.logAction(
                        "start_auction_above_recommendation",
                        this.reservePrice
                    );
                    this.showHeadsUpPopup();
                    break;
                case "other":
                    this.logAction(
                        "start_auction_reserve_price_entered",
                        this.reservePrice
                    );
                    this.startAuction();
            }
        }
    }

    startAuction() {
        WorthyApi.prepareStartAuction(this.props.item.id, {
            seller_notes: this.refs["sellerNotes"].state.value,
            reserve_price: this.reservePrice,
            advance_payment:
                this.props.item.disable_advance_payment_and_price_guarantee ||
                this.props.item.disable_automatic_advance_payment
                    ? false
                    : this.advancePayment,
            price_guarantee: this.props.item
                .disable_advance_payment_and_price_guarantee
                ? false
                : this.priceGuarantee,
        }).then(() => {
            browserHistory.push(
                "/user/payment_details/item/" + this.props.item.id
            );
        });
    }

    onStartAuctionClick() {
        this.removeOverlay();
        this.reservePrice =
            this.reservePrice ||
            Math.floor(this.props.item.recommended_minimum_reserve_price);
        // this.advancePayment = true;
        // this.priceGuarantee = true;
        this.startAuction();
    }

    onStartPGAuctionClick() {
        this.onStartAuctionClick();
        this.logAction("pg_agree_triggered");
    }

    onStartRPAuctionClick() {
        this.onStartAuctionClick();
        this.logAction("rp_agree_triggered");
    }

    onRadioBtnChange(value) {
        const collapsibleSmall = document.querySelector(".collapsible.small"),
            collapsibleBig = document.querySelector(".collapsible.big");
        if (value === "recommended") {
            collapsibleSmall.style.setProperty("max-height", "0px");
            this.reservePrice = Math.floor(
                this.props.item.recommended_minimum_reserve_price
            );
            this.logAction("price_guaranteed_selected");
            this.clearReservePrice();
        } else if (value === "recommendedAdditional5") {
            collapsibleSmall.style.setProperty("max-height", "0px");
            this.reservePrice = Math.floor(this.reservePriceMaxAdditional5Pct);
            this.logAction("5%_above_recommendation_selected");
            this.clearReservePrice();
        } else {
            collapsibleSmall.style.setProperty(
                "max-height",
                collapsibleSmall.scrollHeight + "px"
            );
            collapsibleBig.style.setProperty(
                "max-height",
                collapsibleBig.scrollHeight +
                    collapsibleSmall.scrollHeight +
                    "px"
            );
            ReactScroll.animateScroll.scrollToBottom({
                duration: 300,
                delay: 0,
                smooth: true,
            });
            this.reservePrice =
                this.refs["custom-reserve-price"].state.value || 0;
            this.logAction("other_reserve_price_selected");
            document.querySelector("#custom-reserve-price").focus();
            this.clearReservePrice();
        }
    }

    clearReservePrice() {
        this.refs["custom-reserve-price"].setValue("");
        this.refs["custom-reserve-price"].clearErrors();
        document.querySelector(
            ".additional-text"
        ).innerHTML = `${this.reservePriceMaxDollars} Recommended`;
        document.querySelector(".additional-text").style.color = "";
    }

    onCustomReservePriceChanged(e) {
        let value = parseInt(e.target.value.replace(/\,/g, "")) || "",
            recommendedValue =
                this.props.item.recommended_minimum_reserve_price,
            additionalTextElm = document.querySelector(".additional-text"),
            newAdditionalText;
        this.refs["custom-reserve-price"].setValue(value.toLocaleString("en"));
        this.refs["custom-reserve-price"].clearErrors();
        this.reservePrice = value;
        this.advancePayment = false;
        this.priceGuarantee = false;
        if (!value) {
            newAdditionalText = `${this.reservePriceMaxDollars} Recommended`;
            additionalTextElm.style.color = "";
        } else {
            let stepsMap = I18n.getVar(
                    `itemPage::pendingAuction::${this.state.textVersion}::noGuarantee::hidden::percentageSteps`
                ),
                textColor;
            if (value <= recommendedValue) {
                // do not show any info message in case user type value less then reserved price..
                newAdditionalText = "";
            } else {
                for (let step in stepsMap) {
                    if (value > (recommendedValue * parseInt(step)) / 100)
                        continue;
                    else {
                        newAdditionalText = `${stepsMap[step]}% chance of success`;
                        textColor = ["80", "100"].includes(stepsMap[step])
                            ? "#7ED321"
                            : "#666666";
                        break;
                    }
                }
                additionalTextElm.style.color = textColor;
            }
        }
        if (newAdditionalText !== additionalTextElm.innerHTML) {
            additionalTextElm.innerHTML = newAdditionalText;
            this.logAction(newAdditionalText.replace(/ /g, "_"));
        }
    }

    onSwitchButtonClick() {
        if (!this.collapsibleOpened) {
            this.collapsibleOpened = true;
            this.logAction("set_manually_btn_clicked");
            let collapsibleElm = document.querySelector(".collapsible.big");
            collapsibleElm.style.setProperty(
                "max-height",
                collapsibleElm.scrollHeight + "px"
            );
            setTimeout(
                () => collapsibleElm.style.setProperty("transition", "none"),
                700
            );
            ReactScroll.animateScroll.scrollToBottom({
                duration: 700,
                delay: 0,
                smooth: true,
            });
            document.getElementById("switch-btn").innerText = I18n.getString(
                `itemPage::pendingAuction::${this.state.textVersion}::priceGuarantee::cta`
            );
            this.setState({ setManually: true });
        } else {
            // this.advancePayment = false;
            // this.priceGuarantee = false;
            this.tryStartAuction();
        }
    }
}
